import { Loader2, Plus, Search } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAdminUsers } from "@/lib/api";

import { AdminShell } from "../admin-shell";
import { InviteUserDialog } from "./invite-user-dialog";
import { UserTable } from "./user-table";

export function AdminUsersPage() {
  const usersQuery = useAdminUsers();
  const [search, setSearch] = useState("");
  const [inviteOpen, setInviteOpen] = useState(false);

  const users = usersQuery.data ?? [];
  const filtered = users.filter((u) => {
    const q = search.toLowerCase();
    return (
      u.email.toLowerCase().includes(q) ||
      (u.first_name ?? "").toLowerCase().includes(q) ||
      (u.last_name ?? "").toLowerCase().includes(q)
    );
  });

  return (
    <AdminShell
      title="Users"
      actions={
        <Button onClick={() => setInviteOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Invite user
        </Button>
      }
    >
      {usersQuery.isLoading ? (
        <div className="border-border flex justify-center rounded-2xl border bg-white py-16">
          <Loader2 className="text-muted h-6 w-6 animate-spin" />
        </div>
      ) : usersQuery.isError ? (
        <div className="border-border rounded-2xl border bg-white py-12 text-center">
          <p className="text-muted text-[15px]">
            Could not load users. Please{" "}
            <button
              type="button"
              onClick={() => void usersQuery.refetch()}
              className="text-accent underline"
            >
              try again
            </button>{" "}
            or{" "}
            <Link to="/home" className="text-accent underline">
              go back
            </Link>
            .
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="relative max-w-md">
            <Search className="text-muted absolute top-1/2 left-3.5 h-4 w-4 -translate-y-1/2" />
            <Input
              placeholder="Search users..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="h-11 pl-10"
            />
          </div>
          <UserTable users={filtered} />
          <InviteUserDialog open={inviteOpen} onOpenChange={setInviteOpen} />
        </div>
      )}
    </AdminShell>
  );
}
